module.exports = __webpack_public_path__ + "img/ClickForSound_20.2d9bdbbe.png";